export const formatCurrency = (value, currency = 'INR') =>
  `${currency} ${Number(value || 0).toLocaleString()}`;

export const formatNumber = (value) => Number(value || 0).toLocaleString();

export const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;
